export default {
      id: "icon-slide-button-left-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-slide-button-left",
      toString: function () {
        return this.url;
      }
    }